<template>
  <div class="row-box">
    <WrapperField
      v-for="(fieldValue, fieldName) in orderedDetails"
      :key="fieldValue + fieldName"
      :data="
        createDataField({
          fieldName,
          fieldValue,
          fieldGroup: FieldGroup.ACCEPTANCE_ESCROW_DETAILS,
          fieldGroupEdit: data.dealForm,
        })
      "
    />
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { dealFormToLabel } from '@/utils/services';
import { FieldName } from '@/constants';

const ORDERED_DETAILS = [
  FieldName.acceptanceEscrowDetails.DEAL_FORM,
  FieldName.acceptanceEscrowDetails.DEAL_INFO_REG_NUM,
  FieldName.acceptanceEscrowDetails.DEAL_INFO_NOTARY_INFO,
  FieldName.acceptanceEscrowDetails.DEAL_INFO_DATE,
  FieldName.acceptanceEscrowDetails.DEPOSIT_AMOUNT,
];

export default {
  name: 'Step3',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    dealFormToLabel,
    createDataField,
    FieldGroup,
  }),
  computed: {
    orderedDetails() {
      const details = {};

      ORDERED_DETAILS.forEach((fieldName) => {
        if (Object.prototype.hasOwnProperty.call(this.data, fieldName)) {
          details[fieldName] = this.data[fieldName];
        }
      });

      return details;
    },
  },
};
</script>
